import Controller from '@ember/controller';
import { action, computed, get, set, setProperties } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { task } from 'ember-concurrency';

export default Controller.extend({
  communicationsService: service(),
  fundsService: service(),
  router: service(),

  queryParams: ['contactId', 'fromDetailPage'],

  error: null,
  contactId: null,
  fromDetailPage: null,

  reset() {
    setProperties(this, {
      error: null,
      contactId: null,
      fromDetailPage: null,
    });
  },

  reasons: alias('communicationsService.reasons'),
  mediums: alias('communicationsService.mediums'),

  cancelRoute: computed('model.record.id', function () {
    let route = undefined;
    if (get(this, 'model.record.isNew')) {
      if (get(this, 'model.returnToContactDetailsPage')) {
        route = 'funds.fund.contacts.contact';
      }
    }
    return route;
  }),
  cancelRouteParams: computed('model.record.id', function () {
    let params = undefined;
    if (get(this, 'model.record.isNew')) {
      if (get(this, 'model.returnToContactDetailsPage')) {
        params = get(this, 'model.record.contactId');
      }
    }
    return params;
  }),
  deleteRoute: computed('model.record.isNew', function () {
    if (get(this, 'model.record.isNew')) {
      return undefined;
    }
    return 'funds.fund.tasks.delete';
  }),
  deleteRouteParams: computed('model.record.id', function () {
    if (get(this, 'model.record.isNew')) {
      return undefined;
    }
    return get(this, 'model.record.id');
  }),
  showCompletedAtDate: computed(
    'model.record.isNew',
    'model.record.completedAt',
    'model.changeset.completedAt',
    function () {
      return (
        this.model.record.isNew ||
        isPresent(this.model.record.completedAt) ||
        isPresent(get(this, 'model.changeset.completedAt'))
      );
    },
  ),
  showSaved: computed('model.saved', 'model.changeset.isPristine', function () {
    return this.model.saved && get(this, 'model.changeset.isPristine');
  }),
  showGoBack: alias('model.saved'),
  showCreateCommunication: computed(
    'model.record.isNew',
    'model.record.completedAt',
    'model.record.contactId',
    function () {
      return (
        !this.model.record.isNew &&
        isPresent(this.model.record.completedAt) &&
        isPresent(this.model.record.contactId)
      );
    },
  ),
  showSaveFormActions: computed(
    'model.saved',
    'model.changeset.isDirty',
    function () {
      return !this.model.saved || get(this, 'model.changeset.isDirty');
    },
  ),

  save: task(function* () {
    let changeset = this.model.changeset;
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      try {
        yield this.fundsService.confirmValidFundToken();
        yield changeset.save();
        set(this, 'model.saved', true);
      } catch (error) {
        if (get(this, 'model.record.errors.length') > 0) {
          get(this, 'model.record.errors').forEach(({ attribute, message }) => {
            changeset.pushErrors(attribute, message);
          });
        } else {
          set(this, 'error', error);
        }
      }
    }
  }).drop(),

  markComplete: action(function () {
    set(this, 'model.changeset.completedAt', new Date());
    this.save.perform();
  }),

  goBack: action(function () {
    if (
      this.model.returnToContactDetailsPage &&
      isPresent(get(this, 'changeset.contactId'))
    ) {
      this.router.transitionTo(
        'funds.fund.contacts.contact',
        get(this, 'changeset.contactId'),
      );
    } else {
      window.history.back();
    }
  }),
});
